function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeliveryLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    height: 8,
    id: "screenshot-04ac119d-ee12-8016-8005-e73302d17b30",
    viewBox: "0 0 8 8",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-04ac119d-ee12-8016-8005-e73302d17b30",
    width: 800,
    height: 800,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-04ac119d-ee12-8016-8005-e73302d280ff",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-04ac119d-ee12-8016-8005-e73302d280ff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8.000000000000014,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-04ac119d-ee12-8016-8005-e73302d37ab2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-04ac119d-ee12-8016-8005-e73302d37ab2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.525,0.768C4.017,0.276,4.683,0.000,5.379,0.000C6.826,0.000,8.000,1.174,8.000,2.621C8.000,3.317,7.724,3.983,7.232,4.475L6.207,5.500L5.500,4.793L6.525,3.768C6.829,3.464,7.000,3.051,7.000,2.621C7.000,1.726,6.274,1.000,5.379,1.000C4.949,1.000,4.536,1.171,4.232,1.475L3.207,2.500L2.500,1.793L3.525,0.768ZZ",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-04ac119d-ee12-8016-8005-e73302d3be75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-04ac119d-ee12-8016-8005-e73302d3be75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.768,6.525L4.793,5.500L5.500,6.207L4.475,7.232C3.983,7.724,3.317,8.000,2.621,8.000C1.174,8.000,0.000,6.826,0.000,5.379C0.000,4.683,0.276,4.017,0.768,3.525L1.793,2.500L2.500,3.207L1.475,4.232C1.171,4.536,1.000,4.949,1.000,5.379C1.000,6.274,1.726,7.000,2.621,7.000C3.051,7.000,3.464,6.829,3.768,6.525ZZ",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-04ac119d-ee12-8016-8005-e73302d3be76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-04ac119d-ee12-8016-8005-e73302d3be76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.854,5.854L5.854,2.854L5.146,2.146L2.146,5.146L2.854,5.854ZZ",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeliveryLink);
export default __webpack_public_path__ + "static/media/icon-delivery-link.6414176c58aa1bef97eb14b95917b4dc.svg";
export { ForwardRef as ReactComponent };